const setCookie = function (name, value, day) {
  // 获取本地时间戳
  const time = new Date()
  // 改变当前时间  将当前的时间减去8小时
  time.setTime(time.getTime() - 8 * 60 * 60 * 1000 + day * 1000 * 60 * 60 * 24)
  console.log(time)
  document.cookie = `${name}=${value};expires=${time}`
}

const getCookie = function (key) {
  // 获取当前域下面所有的cookie 'key=value; key2=value2; key3=value3'
  const allCookieStr = document.cookie
  // 按照; 的方式来拆分字符串得到一个新数组，新数组里面的每一项就是一条cookie数据
  const arrCookie = allCookieStr.split('; ')
  // [key=value,key2=value2,key3=value3]
  const obj = {}
  // 遍历数组，把他组合成{key:value,key2:value2,key3:value3}
  for (let i = 0; i < arrCookie.length; i++) {
    // 得到数组每一项，再按照=的方式拆分，得到一个新数组 ['key','value']
    // 数组的第一项就是对象key 数组第二项就是对象value
    const arr = arrCookie[i].split('=')
    obj[arr[0]] = arr[1]
  }
  console.log(obj[key]);
  return obj[key]
}

export {
  setCookie,
  getCookie
}